const bci = {
  FORMS: [],
  CSS: {
    id: '64d9200b6f964c7f5a4q4a21',
    name: 'bci',
    avatar: {
      name: 'BCI',
      header: 'https://chatbotqa.gatblac.com/static/avatar/bci/logo_bci_negro.svg',
      new: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-new.png',
      open: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-open.png',
      close: 'https://chatbotqa.gatblac.com/static/avatar/gatblac-trial/avatar-blue-close.png'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#007BFF',
        borderColor: '#007BFF'
      }
    }
  }
}
export default bci
